module.exports = __webpack_public_path__ + "img/logo2.b68e6e84.png";